export default function() {
  var nodes = [];
  this.each(function(node) {
    nodes.push(node);
  });
  return nodes;
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-hierarchy/src/hierarchy/descendants.js
// module id = Hidq
// module chunks = 0